import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { WhatWeBuildSection } from "@/components/sections/WhatWeBuildSection";
import { CTASection } from "@/components/sections/CTASection";
import { SEO } from "@/components/SEO";

const WhatWeBuild = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="What We Build | It's All About Growth"
        description="Concrete deliverables, playbooks, and revenue infrastructure we install with B2B service teams — built to outlast the engagement."
        path="/what-we-build"
      />
      <Header />
      <main className="pt-20">
        <WhatWeBuildSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default WhatWeBuild;
